<div #multiselectDropdown>
    <div class="paragragh" (click)="showDropDown = !showDropDown" (keypress)="showDropDown = !showDropDown">
        <p aria-live="polite">
            {{ totalCheckedAmount+' selected' }}
        </p>
        <button class="arrowIcon ods-btn-ghost"
            [ngClass]="{'upArrow': showDropDown}"
            aria-label="View sensitive information access options"
            aria-controls="securitySetListbox"
            [attr.aria-expanded]="showDropDown"
            aria-haspopup="menu"
        >
        </button>
    </div>

    <ul id="securitySetListbox"
        *ngIf="showDropDown"
        aria-labelledby="sensitiveInformationLabel"
    >
            <li>
                <input id="InfoAccessSelectAllCheckbox"
                    type="checkbox"
                    class="ods-checkbox"
                    [checked] = "isSelectAll"
                    [disabled]="disabled ? true : undefined"
                    (change)="selectAll($event.currentTarget.checked)"
                >
                <label for="InfoAccessSelectAllCheckbox">
                    Select All
                </label>

            </li>
            <li *ngFor="let item of dropdownList; let i = index">
                <input type="checkbox"
                    [id]="'sesitiveInformationAccessCheckbox' + i"
                    class="ods-checkbox"
                    [checked]="item.isChecked"
                    [disabled]="disabled ? true : undefined"
                    (change)="isOptionChecked(i, $event.currentTarget.checked)"
                >
                <label [for]="'sesitiveInformationAccessCheckbox' + i">
                    {{item.name}}
                </label>
            </li>
    </ul>
</div>
